<li ngbDropdown #notificationDropdown="ngbDropdown" class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown">
    <i class="ficon" data-feather="bell"></i>
    <span *ngIf="unreadCount > 0" class="badge badge-pill badge-danger badge-up">
      {{ unreadCount }}
    </span>
  </a>
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <div class="badge badge-pill badge-light-primary" *ngIf="unreadCount > 0">
          {{ unreadCount }} Nouveau
        </div>
      </div>
    </li>
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <div *ngIf="notifications.length === 0" class="text-center p-2">
        <p>Aucune notification</p>
      </div>
      <a
        *ngFor="let notification of notifications"
        class="d-flex"
        href="javascript:void(0)"
        (click)="navigateToNotification(notification)"
      >
        <div
          class="media d-flex align-items-start"
          [ngClass]="{ 'bg-light-gray': !notification.isRead }"
        >
          <div class="media-left">
            <div class="avatar" [ngClass]="getNotificationClass(notification.type)">
              <div class="avatar-content">
                <i class="avatar-icon" [data-feather]="getNotificationIcon(notification.type)"></i>
              </div>
            </div>
          </div>
          <div class="media-body">
            <p class="media-heading">{{ notification.title }}</p>
            <small class="notification-text">{{ notification.message }}</small>
            <small class="text-muted mt-1 d-block">{{
              notification.createdAt | date : "dd MMM, HH:mm"
            }}</small>
          </div>
        </div>
      </a>
      <!-- Fin de la boucle des notifications -->
    </li>
    <li class="dropdown-menu-footer">
      <button
        class="btn btn-primary btn-block"
        [disabled]="notifications.length === 0"
        (click)="markAllAsRead()"
      >
        Tout marquer comme lu
      </button>
    </li>
  </ul>
</li>
